import * as React from 'react'

import i18n from 'modules/core/lib/i18n'
import { NavigationRoutesFn } from 'modules/core/lib/react-router'

import { getSettingPageMeta } from 'modules/settings/lib/getSettingPageMeta'

const RootPage = React.lazy(() => import('modules/compensations/pages/settings/RootPage'))

const SettingsPage = React.lazy(() => import('modules/compensations/pages/settings/SettingsPage'))

const PayrollConcepts = React.lazy(
  () => import('modules/compensations/pages/settings/PayrollConcepts')
)
const EmployeeUpdatesPage = React.lazy(
  () => import('modules/compensations/pages/settings/EmployeeUpdates')
)

const A3nomIntegration = React.lazy(
  () => import('modules/payroll_bundle/pages/settings/A3nomIntegration')
)

const SilaeIntegration = React.lazy(
  () => import('modules/payroll_bundle/pages/settings/SilaeIntegration')
)
const SilaeApiIntegration = React.lazy(
  () => import('modules/integrations_silae_api/pages/Settings')
)
const DatevIntegration = React.lazy(
  () => import('modules/payroll_bundle/pages/settings/DatevIntegration')
)
const DatevApiIntegration = React.lazy(
  () => import('modules/payroll_integrations_datev_api/pages/Settings')
)
const PaierhIntegration = React.lazy(
  () => import('modules/payroll_bundle/pages/settings/PaierhIntegration')
)
const YeapPaierhIntegration = React.lazy(
  () => import('modules/payroll_bundle/pages/settings/YeapPaierhIntegration')
)
const ZucchettiIntegration = React.lazy(
  () => import('modules/payroll_bundle/pages/settings/ZucchettiIntegration')
)
const GispagheIntegration = React.lazy(
  () => import('modules/payroll_bundle/pages/settings/GispagheIntegration')
)
const TimeReimbursementPage = React.lazy(
  () => import('modules/compensations/pages/settings/TimeReimbursementsPage')
)
const ExpensesReimbursementPage = React.lazy(
  () => import('modules/compensations/pages/settings/ExpensesReimbursementsPage')
)

const BenefitsPage = React.lazy(() => import('modules/compensations/pages/settings/BenefitsPage'))

const settingsRoutes: NavigationRoutesFn = (navigation) => {
  return [
    {
      path: navigation.settings.compensations.path,
      element: <RootPage />,
      handle: {
        meta: () => getSettingPageMeta(navigation, 'compensations'),
      },
      children: [
        {
          index: true,
          element: <SettingsPage />,
        },
        {
          path: navigation.settings.compensations.payrollConcepts.path,
          element: <PayrollConcepts />,
          handle: {
            meta: () => ({
              illustration: 'settings',
              title: i18n.t('compensations.settings.concepts.section.title'),
              description: i18n.t('compensations.settings.concepts.section.description'),
              link: {
                href: '#',
                label: i18n.t('compensations.settings.help'),
              },
            }),
          },
        },
        {
          path: navigation.settings.compensations.employeeUpdates.path,
          element: <EmployeeUpdatesPage />,
          handle: {
            meta: () => ({
              title: i18n.t('app_store_v2.apps.payroll_bundle.settings.incidences.settings'),
            }),
          },
        },
        {
          path: navigation.settings.compensations.integrationA3nom.path,
          element: <A3nomIntegration />,
          handle: {
            meta: () => ({
              title: i18n.t(
                'app_store_v2.app_integrations.payroll_integrations_a3nom.general.title'
              ),
              description: i18n.t(
                'app_store_v2.app_integrations.payroll_integrations_a3nom.general.description'
              ),
              illustration: 'smart-document',
            }),
          },
        },
        {
          path: navigation.settings.compensations.integrationDatev.path,
          element: <DatevIntegration />,
          handle: {
            meta: () => ({
              title: i18n.t(
                'app_store_v2.app_integrations.payroll_integrations_datev.general.title'
              ),
              description: i18n.t(
                'app_store_v2.app_integrations.payroll_integrations_datev.general.description'
              ),
              illustration: 'smart-document',
            }),
          },
        },
        {
          path: navigation.settings.compensations.integrationDatevApi.path,
          element: <DatevApiIntegration />,
          handle: {
            meta: () => ({
              title: i18n.t(
                'app_store_v2.app_integrations.payroll_integrations_datev_api.general.title'
              ),
              description: i18n.t(
                'app_store_v2.app_integrations.payroll_integrations_datev_api.general.description'
              ),
              illustration: 'smart-document',
            }),
          },
        },
        {
          path: navigation.settings.compensations.integrationZucchetti.path,
          element: <ZucchettiIntegration />,
          handle: {
            meta: () => ({
              title: i18n.t(
                'app_store_v2.app_integrations.payroll_integrations_zucchetti.general.title'
              ),
              description: i18n.t(
                'app_store_v2.app_integrations.payroll_integrations_zucchetti.general.description'
              ),
              illustration: 'smart-document',
            }),
          },
        },
        {
          path: navigation.settings.compensations.integrationPaierh.path,
          element: <PaierhIntegration />,
          handle: {
            meta: () => ({
              title: i18n.t(
                'app_store_v2.app_integrations.payroll_integrations_paierh.general.title'
              ),
            }),
          },
        },
        {
          path: navigation.settings.compensations.integrationYeapPaierh.path,
          element: <YeapPaierhIntegration />,
          handle: {
            meta: () => ({
              title: i18n.t(
                'app_store_v2.app_integrations.payroll_integrations_yeap_paierh.general.title'
              ),
            }),
          },
        },
        {
          path: navigation.settings.compensations.integrationYeapPaierh.path,
          element: <YeapPaierhIntegration />,
          handle: {
            meta: () => ({
              title: i18n.t(
                'app_store_v2.app_integrations.payroll_integrations_yeap_paierh.general.title'
              ),
            }),
          },
        },
        {
          path: navigation.settings.compensations.integrationSilae.path,
          element: <SilaeIntegration />,
          handle: {
            meta: () => ({
              title: i18n.t(
                'app_store_v2.app_integrations.payroll_integrations_silae.general.title'
              ),
              description: i18n.t(
                'app_store_v2.app_integrations.payroll_integrations_silae.general.description'
              ),
              illustration: 'smart-document',
            }),
          },
        },
        {
          path: navigation.settings.compensations.integrationSilaeApi.path,
          element: <SilaeApiIntegration />,
          handle: {
            meta: () => ({
              title: i18n.t(
                'app_store_v2.app_integrations.payroll_integrations_silae_api.general.title'
              ),
              description: i18n.t(
                'app_store_v2.app_integrations.payroll_integrations_silae_api.general.description'
              ),
              illustration: 'smart-document',
            }),
          },
        },
        {
          path: navigation.settings.compensations.integrationGispaghe.path,
          element: <GispagheIntegration />,
          handle: {
            meta: () => ({
              title: i18n.t(
                'app_store_v2.app_integrations.payroll_integrations_gispaghe.general.title'
              ),
              description: i18n.t(
                'app_store_v2.app_integrations.payroll_integrations_gispaghe.general.description'
              ),
              illustration: 'smart-document',
            }),
          },
        },
        {
          path: navigation.settings.compensations.timeReimbursement.path,
          element: <TimeReimbursementPage />,
          handle: {
            meta: () => ({
              title: i18n.t('compensations.settings.time_reimbursements.breadcrumb'),
            }),
          },
        },
        {
          path: navigation.settings.compensations.expensesReimbursement.path,
          element: <ExpensesReimbursementPage />,
          handle: {
            meta: () => ({
              title: i18n.t('compensations.settings.expenses_reimbursements.breadcrumb'),
            }),
          },
        },
        {
          path: navigation.settings.compensations.benefits.path,
          element: <BenefitsPage />,
          handle: {
            meta: () => ({
              title: 'Benefits',
            }),
          },
        },
      ],
    },
  ]
}

export default settingsRoutes
